import { RestrictedPage } from "routes/CrudRoute";
import OwnerList from "./OwnerList";
import {
  OwnerChangeMobile,
  OwnerConfirmChangeMobile,
  OwnerAdminChangeMobile,
  OwnerAdminConfirmChangeMobile,
} from "./OwnerChangeMobile";
import { OwnerMergeShop } from "./OwnerMergeShop";
import { DisableEmail } from "./DisableEmail";
import { ShopList } from "./ShopList";
import { ShopMenuList } from "./ShopMenuList";
import { ShopMenuImport } from "./ShopMenuImport";
import { ShopMenuPreset } from "./ShopMenuPreset";
import ShopMenuDelete from "./ShopMenuDelete";
import { ShopReportResend } from "./ShopReportResend";
import {
  ShopTemplateList,
  ShopCategoryList,
  ShopItemList,
} from "./ShopTemplateList";
import {
  ShopTemplateCreate,
  ShopCategoryCreate,
  ShopItemCreate,
} from "./ShopTemplateCreate";
import {
  ShopTemplateEdit,
  ShopCategoryEdit,
  ShopItemEdit,
} from "./ShopTemplateEdit";
import { ShopCategoryDetail } from "./ShopTemplateDetail";
import { ShopPushDeviceList } from "./ShopPushDeviceList";

import * as urls from "./urls";
import { ShopLoginWhitelist } from "./ShopLoginWhitelist";
import { ShopLoginWhitelistCreate } from "./ShopLoginWhitelistCreate";
import { ShopLoginWhitelistEdit } from "./ShopLoginWhitelistEdit";

import ShopDisableList from "./ShopDisableList";
import ShopDisableRequest from "./ShopDisableRequest";
import ShopUnblockList from "./ShopUnblockList";
import ShopUnblockRequest from "./ShopUnblockRequest";
import ShopForceUnblockRequest from "./ShopForceUnblockRequest";
import ShopLoginDisableList from "./ShopLoginDisable";

export const OwnerResourceName = "Shop Owner";
export const ShopResourceName = "Shop";
export const ShopMenuResourceName = "Shop Menu";
export const ShopTemplateResourceName = "Shop Template";
export const ShopCategoryResourceName = "Shop Category";
export const ShopItemResourceName = "Shop Item";
export const ShopLoginWhietlistResourceName = "Shop Login Whitelist";
export const ShopDisableResourceName = "Delete Branch";
export const ShopUnblockResourceName = "Shop Enable";
export const ShopLoginDisableResourceName = "Disabled account";
export const ShopDisableEmail = "Shop Disable Email";

export const ShopResources = [
  {
    name: OwnerResourceName,
    frontendPath: urls.ownerFrontendPath,
    backendPath: urls.ownerBackendPath,
    list: OwnerList,
    showInSideMenu: true,
  },
  {
    name: ShopTemplateResourceName,
    frontendPath: urls.shopTemplateFrontendPath,
    backendPath: urls.shopTemplateBackendPath,
    list: ShopTemplateList,
    create: ShopTemplateCreate,
    edit: ShopTemplateEdit,
    showInSideMenu: true,
  },
  {
    name: ShopCategoryResourceName,
    frontendPath: urls.shopCategoryFrontendPath,
    backendPath: urls.shopCategoryBackendPath,
    list: ShopCategoryList,
    create: ShopCategoryCreate,
    edit: ShopCategoryEdit,
    show: ShopCategoryDetail,
    showInSideMenu: true,
  },
  {
    name: ShopItemResourceName,
    frontendPath: urls.shopItemFrontendPath,
    backendPath: urls.shopItemBackendPath,
    list: ShopItemList,
    create: ShopItemCreate,
    edit: ShopItemEdit,
    showInSideMenu: true,
  },
  {
    name: ShopMenuResourceName,
    frontendPath: urls.shopMenuListFrontendPath,
    backendPath: urls.shopMenuListBackendPath,
    list: ShopMenuList,
    showInSideMenu: true,
  },
  {
    name: ShopLoginWhietlistResourceName,
    frontendPath: urls.shopLoginWhitelistFrontendPath,
    backendPath: urls.shopLoginWhitelistBackendPath,
    list: ShopLoginWhitelist,
    create: ShopLoginWhitelistCreate,
    edit: ShopLoginWhitelistEdit,
    showInSideMenu: true,
  },
  {
    name: ShopResourceName,
    frontendPath: urls.shopFrontendPath,
    backendPath: urls.shopBackendPath,
    list: ShopList,
    showInSideMenu: true,
  },
  {
    name: ShopDisableResourceName,
    frontendPath: urls.shopDisableFrontendPath,
    backendPath: urls.shopDisableBackendPath,
    list: ShopDisableList,
    showInSideMenu: true,
  },
  {
    name: ShopUnblockResourceName,
    frontendPath: urls.shopUnblockFrontendPath,
    backendPath: urls.shopBackendPath,
    list: ShopUnblockList,
    showInSideMenu: true,
  },
  {
    name: ShopLoginDisableResourceName,
    frontendPath: urls.shopLoginDisableFrontendPath,
    backendPath: urls.shopLoginDisableBackendPath,
    list: ShopLoginDisableList,
    showInSideMenu: true,
  },
  {
    name: ShopDisableEmail,
    frontendPath: urls.emailByShopFrontendPath,
    backendPath: urls.emailByShopBackendPath,
    showInSideMenu: false,
  },
];

export const ShopCustomRoutes = [
  {
    name: "Owner Change Mobile",
    frontendPath: urls.ownerChangeMobileFrontendPath,
    showInSideMenu: false,
    render: RestrictedPage(OwnerChangeMobile, "owner mobile", {
      resource: OwnerResourceName,
      redirectPath: urls.ownerConfirmChangeMobileFrontendPath,
    }),
  },
  {
    name: "Owner Change Mobile Confirm",
    frontendPath: urls.ownerConfirmChangeMobileFrontendPath,
    showInSideMenu: false,
    render: RestrictedPage(OwnerConfirmChangeMobile, "owner mobile", {
      resource: OwnerResourceName,
      updateDataOnMount: false,
      redirectPath: urls.ownerFrontendPath,
    }),
  },
  {
    name: "Owner Admin Change Mobile",
    frontendPath: urls.ownerAdminChangeMobileFrontendPath,
    showInSideMenu: false,
    render: RestrictedPage(OwnerAdminChangeMobile, "owner admin mobile", {
      resource: OwnerResourceName,
      redirectPath: urls.ownerAdminConfirmChangeMobileFrontendPath,
    }),
  },
  {
    name: "Owner Admin Change Mobile Confirm",
    frontendPath: urls.ownerAdminConfirmChangeMobileFrontendPath,
    showInSideMenu: false,
    render: RestrictedPage(
      OwnerAdminConfirmChangeMobile,
      "owner admin mobile",
      {
        resource: OwnerResourceName,
        updateDataOnMount: false,
        redirectPath: urls.ownerFrontendPath,
      }
    ),
  },
  {
    name: "Owner Merge Shop",
    frontendPath: urls.ownerMergeShopFrontendPath,
    showInSideMenu: false,
    render: RestrictedPage(OwnerMergeShop, "owner merge shop", {
      resource: OwnerResourceName,
      redirectPath: urls.ownerFrontendPath,
    }),
  },
  {
    name: "Shop Disable Email",
    frontendPath: urls.emailByShopFrontendPath,
    showInSideMenu: false,
    render: RestrictedPage(DisableEmail, "Shop Disable Email", {
      resource: ShopDisableEmail,
      editBackendPath: urls.emailByShopBackendPath,
      redirectPath: urls.shopFrontendPath,
    }),
  },
  {
    name: "Shop Report Resend",
    frontendPath: urls.shopReportResendFrontendPath,
    showInSideMenu: false,
    render: RestrictedPage(ShopReportResend, "shop report resend", {
      resource: ShopResourceName,
      editBackendPath: urls.shopReportResendBackendPath,
      redirectPath: urls.shopFrontendPath,
    }),
  },
  {
    name: "Shop Push Device List",
    frontendPath: urls.shopPushDeviceListFrontendPath,
    showInSideMenu: false,
    render: RestrictedPage(ShopPushDeviceList, "shop push device list", {
      resource: ShopResourceName,
      editBackendPath: urls.shopPushDeviceListBackendPath,
      redirectPath: urls.shopFrontendPath,
    }),
  },
  {
    name: "Shop Menu Import",
    frontendPath: urls.shopMenuImportFrontendPath,
    showInSideMenu: false,
    render: RestrictedPage(ShopMenuImport, "shop menu import", {
      resource: ShopMenuResourceName,
      editBackendPath: urls.shopMenuImportBackendPath,
      redirectPath: urls.shopMenuListFrontendPath,
    }),
  },
  {
    name: "Shop Menu Preset",
    frontendPath: urls.shopMenuPresetFrontendPath,
    showInSideMenu: false,
    render: RestrictedPage(ShopMenuPreset, "shop menu preset", {
      resource: ShopMenuResourceName,
      editBackendPath: urls.shopMenuPresetBackendPath,
      redirectPath: urls.shopMenuListFrontendPath,
      title: "Shop Menu Preset",
    }),
  },
  {
    name: "Shop Menu Delete",
    frontendPath: urls.shopMenuDeleteFrontendPath,
    showInSideMenu: false,
    render: RestrictedPage(ShopMenuDelete, "shop menu delete", {
      resource: ShopMenuResourceName,
      editBackendPath: urls.shopMenuDeleteBackendPath,
      updateDataOnMount: false,
      redirectPath: urls.shopMenuListFrontendPath,
      title: "Shop Menu Delete",
    }),
  },
  {
    name: "Delete Branch request",
    frontendPath: urls.shopDisableRequestFrontendPath,
    showInSideMenu: false,
    render: RestrictedPage(ShopDisableRequest, "", {
      resource: ShopDisableResourceName,
      redirectPath: urls.shopDisableFrontendPath,
    }),
  },
  {
    name: "Shop Enable request",
    frontendPath: urls.shopUnblockRequestFrontendPath,
    showInSideMenu: false,
    render: RestrictedPage(ShopUnblockRequest, "", {
      resource: ShopUnblockResourceName,
      redirectPath: urls.shopUnblockFrontendPath,
    }),
  },
  {
    name: "Shop Force Enable request",
    frontendPath: urls.shopUnblockForceRequestFrontendPath,
    showInSideMenu: false,
    render: RestrictedPage(ShopForceUnblockRequest, "", {
      resource: ShopUnblockResourceName,
      redirectPath: urls.shopUnblockFrontendPath,
    }),
  },
];



// WEBPACK FOOTER //
// ./src/routes/shop/resources.js